import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core'
import { Dictionary } from '@ngrx/entity'
import { InstrumentAndPlanHelper } from '../instrument-and-plan-helper'
import { Observable } from 'rxjs'
import { FilterableTableColumn, AutoFilterTableComponent } from '../auto-filter-table/auto-filter-table.component'
import { StripTagsPipe } from '../../pipes/striptags.pipe'
import { PlanTreatmentsUnclassifiedComponent } from '../plan-treatment-unclassified/plan-treatment-unclassified'
import { PlanTreatmentsClassifiedComponent } from '../plan-treatment-classified/plan-treatment-classified'
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap'
import { NgIcon, provideIcons } from '@ng-icons/core'
import { bootstrapCaretDownFill, bootstrapCaretUpFill, bootstrapChevronDown, bootstrapInfoCircle } from '@ng-icons/bootstrap-icons'

import { CourtDocumentsComponent } from '../court-documents/court-documents'
import { BondPricingGraphComponent } from '../bond-pricing-graph/bond-pricing-graph.component'
import { NgTemplateOutlet, TitleCasePipe, CurrencyPipe, DatePipe } from '@angular/common'
import { CdkTableModule } from '@angular/cdk/table'
import { openClose } from '../../animations/open-close-animations'
import { FollowableLinkComponent } from '../followable-link/followable-link.component'
import { EquityPricingGraphComponent } from '../equity-pricing-graph/equity-pricing-graph.component'

@Component({
    selector: 'app-instrument-view',
    templateUrl: './instrument-view.component.html',
    styleUrls: ['./instrument-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CdkTableModule,
        NgTemplateOutlet,
        BondPricingGraphComponent,
        AutoFilterTableComponent,
        CourtDocumentsComponent,
        NgIcon,
        NgbTooltip,
        PlanTreatmentsClassifiedComponent,
        PlanTreatmentsUnclassifiedComponent,
        TitleCasePipe,
        CurrencyPipe,
        DatePipe,
        StripTagsPipe,
        FollowableLinkComponent,
        EquityPricingGraphComponent,
    ],
    providers: [
      provideIcons({
        bootstrapChevronDown,
        bootstrapInfoCircle,
        bootstrapCaretDownFill,
        bootstrapCaretUpFill
      }),
    ],
    animations: [
        openClose,
    ]
})
export class InstrumentViewComponent extends InstrumentAndPlanHelper implements OnInit {
  @Input() set article(article: any) {
    this.instrument = article.extras
  }
  @Input() instrument: any = {}

  @Input() canShowFactSetData = false

  public involvedPartyRoleTitle: Dictionary<string> = {
    "Lender": 'DEBT/EQUITY - Funded Debt Holder (Note/Loan)',
    "Admin Agent": 'DEBT/EQUITY - Administrative Agent',
    "Collateral Agent": 'DEBT/EQUITY - Collateral Agent',
    "Indenture Trustee": ' DEBT/EQUITY - Indenture Trustee',
    "Underwriter": 'DEBT/EQUITY - Underwriter/Arranger',
    "Arranger": 'DEBT/EQUITY - Underwriter/Arranger',
    "Counterparty": 'OPERATION - Significant Vendor/Contract Counterparty'
  }
  public instrumentUIUD = ''

  public instrumentHoldingsColumns: FilterableTableColumn[] = [
    {
      name: 'date',
      title: 'Date',
      type: 'date',
      sortable: true,
      filterable: false,
    },
    {
      name: 'entity_name',
      title: 'Entity',
      type: 'text',
      sortable: true,
      filterable: true,
      sortby: 'entity_name',
      sorted: 'asc'
    },
    {
      name: 'group',
      title: 'Group',
      type: 'text',
      sortable: true,
      filterable: true,
    },
    {
      name: 'position',
      title: 'Position',
      type: 'text',
      sortable: true,
      filterable: true,
    },
    {
      name: 'holdingValue',
      title: 'Value',
      type: 'text',
      sortable: true,
      filterable: false,
      sortby: 'holding',
    },
  ]


  public updateUIUD(uiud: string) {
    this.instrumentUIUD = uiud
  }

  public isDIP: boolean = false
  public dipDataForCurrentStatus: any = {}
  public selectedArticle$: Observable<any> = new Observable()

  public isHoldingExpanded: Dictionary<boolean> = {}

  public year = new Date().getFullYear()

  ngOnInit(): void {
    this.isDIP = (this.instrument.dip_status)
  }

  isStructureBondWithFigi(structure: any) {
    if (structure?.instrument_type === 'Bond/Note') {
      const figiID = structure.instrument_ids?.find((id: any) => id.id_type === 'FIGI')
      if (figiID) {
        return figiID.id_value
      }
    }
    return false
  }

  instrumentIsBondWithFigi() {
    return this.isStructureBondWithFigi(this.instrument.openfigi) || this.isStructureBondWithFigi(this.instrument)
  }

  ifStringConvertToFloat(value: any) {
    if (typeof value === 'string') {
      return parseFloat(value.replace(/,/g, ''))
    }
    return value
  }

  gotoInstrument(elementID: string) {
    const element = document.getElementById('instrument-' + elementID) as HTMLElement
    element.scrollIntoView({ behavior: 'smooth' })
    element.click()
  }

  isStringWithCommas(value: any) : boolean {
    return typeof value == 'string' && value?.includes(',')
  }

  isDateString(value: string) : boolean {
    return value.match(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/) !== null
  }
}